import script from "./TaskViewGrantMatrix.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskViewGrantMatrix.vue?vue&type=script&setup=true&lang=js"

import "./TaskViewGrantMatrix.vue?vue&type=style&index=0&id=10a9f493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a9f493"]])

export default __exports__